/**
 * Shared app route paths.
 *
 * Lives outside Router.tsx so the sidebar can link to a route without the
 * eager Router bundle pulling in the sidebar (and the component library).
 */

/** Card home with the fixed sections (`/workspace`). */
export const WORKSPACE_ROUTE = '/workspace';

/** Account flag that makes `/workspace` the `/` landing and the sidebar logo target. */
export const WORKSPACE_ENABLED_FLAG = 'workspace_enabled';
